import React from 'react';
import Modal from '../../../Modal';

export default function ConversionPreview({conversion, onCancel, onConfirm}) {
    if (!conversion) return null;
    return <Modal
        isOpen
        title={`Convert to ${conversion.format === 'markdown' ? 'Markdown' : 'HTML'}?`}
        onClose={onCancel}
        footer={<>
            <button type="button" className="button secondary" onClick={onCancel}>Cancel</button>
            <button type="button" className="button" onClick={onConfirm}>Use converted content</button>
        </>}
    >
        <p>This replaces the current source only after you confirm. It does not publish the page.</p>
        {conversion.warnings?.length > 0 && <div className="flash warning" role="alert">
            <strong>Some details may not round-trip:</strong>
            <ul>{conversion.warnings.map(warning => <li key={warning}>{warning}</li>)}</ul>
        </div>}
        <div className="content-conversion-columns">
            <div>
                <h3>Converted source</h3>
                <pre>{conversion.content}</pre>
            </div>
            <div>
                <h3>Storefront preview</h3>
                <div className="readable" dangerouslySetInnerHTML={{__html: conversion.previewHtml}} />
            </div>
        </div>
    </Modal>;
}
